import { render, staticRenderFns } from "./LangueFrancaise.vue?vue&type=template&id=5d6ff3da"
import script from "./LangueFrancaise.vue?vue&type=script&lang=js"
export * from "./LangueFrancaise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports